<template>
  <div>
    <please-wait class="mt-6" v-if="isLoading"></please-wait>
    <v-card
      flat
      style="max-width: 800px; margin: 0 auto"
      class="pa-md-5 pa-3 mt-6"
      v-if="job.id"
    >
      <p>Please enter the following information to Close out the Job.</p>
      <form-wrapper @submit="submit()">
        <date-time-picker
          v-model="form.technician_closed_at"
          label="TIME CLOSE"
          :rules="rules"
        ></date-time-picker>
        <input-field
          readonly
          v-model="job.job_number"
          label="JOB#"
        ></input-field>
        <input-field
          readonly
          v-model="job.template_name"
          label="JOB TYPE"
        ></input-field>
        <select-field
          label="JOB STATUS"
          @input="onStatusChange"
          :items="jobStatus"
          v-model="form.disposition"
          rules="required"
        ></select-field>
        <select-field
          rules="required"
          v-if="isJobCancelled"
          :items="reasonOptions"
          return-object
          v-model="form.reason"
          label="REASON FOR CANCELLATION"
        ></select-field>
        <template v-if="isJobCompleted">
          <select-field
            rules="required"
            v-model="form.how_paid"
            label="HOW PAID"
            return-object
            item-value="name"
            :items="howPaidOptions"
          ></select-field>
          <input-field
            rules="required"
            v-model="form.invoice"
            label="INVOICE"
          ></input-field>
          <input-field
            v-model="form.total"
            rules="required"
            label="TOTAL COLLECTED"
            type="number"
          ></input-field>
        </template>
        <Textarea v-model="form.comments" label="COMMENTS"></Textarea>
        <div>
          <a :href="scannrUrlLink">
            <v-btn
            class="primary"
            depressed
            @click="scannrUrl"
            tile
            :width="is_mobile ? '' : '120px'"
            color="white"
            :height="$root.dense ? '40px' : '56px'"
            v-if="is_mobile"
          >
          Scan ID
            </v-btn>
          </a>
        </div>
        <v-snackbar
             v-model="showToast"
             :timeout="5000"
             :color="toastColor"
             top
             outlined
             right>
              {{ toastMessage }}</v-snackbar>
        <div>
          <label> UPLOAD PICTURES</label>
          <input
            class="d-none"
            multiple
            ref="file"
            type="file"
            @change="onFileChange"
            accept="image/*"
          />
          <div class="d-flex flex-wrap mt-3">
            <v-card
              width="150px"
              class="mr-5 mb-5 cursor-pointer"
              outlined
              @click="$refs.file.click()"
            >
              <v-card-text class="pb-0 d-flex flex-column align-center">
                <img src="../assets/add-file.png" width="75px" height="75px" />
                <p class="my-2">Add File</p>
              </v-card-text>
            </v-card>
            <v-card
              width="150px"
              outlined
              v-for="(file, i) in form.pictures"
              :key="i"
              class="mr-5 mb-5 cursor-pointer"
               @click="downloadFile(file)"
            >
              <v-card-text class="pb-0 d-flex flex-column align-center">
                <div class="file-remove" @click.stop="removeFile(i)">
                  <v-btn icon color="red">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </div>
                <img src="../assets/file.png" width="75px" height="75px" />
                <p class="my-2 file-name">
                  {{ file.name }}
                </p>
              </v-card-text>
            </v-card>
          </div>
        </div>
        
        <div class="d-flex">
          <v-spacer></v-spacer>
          <primary-button :loading="loading" type="submit"
            >Submit</primary-button
          >
        </div>

      </form-wrapper>
    </v-card>
  </div>
</template>

<script>
import customerModal from "../assets/js/customer.modal";
import appSettingModel from "../assets/js/appSetting.model";
import { FIELD } from "../assets/js/rules";
import DateTimePicker from "../components/DateTimePicker.vue";
import FormWrapper from "../components/ui/form/FormWrapper.vue";
import InputField from "../components/ui/form/InputField.vue";
import SelectField from "../components/ui/form/SelectField.vue";
import PrimaryButton from "../components/ui/btns/PrimaryButton.vue";
import Textarea from "../components/ui/form/Textarea.vue";
import PleaseWait from "../components/PleaseWait.vue";
import {functions, scans } from "../assets/js/firebase";
import moment from "moment";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
export default {
  components: {
    FormWrapper,
    InputField,
    SelectField,
    Textarea,
    DateTimePicker,
    PrimaryButton,
    PleaseWait,
  },
  data() {
    return {
      scannrUrlLink:null,
      rules: FIELD,
      isLoading: true,
      job: {},
      fields: [],
      loading: false,
      form: {
        technician_closed_at: moment().format("YYYY-MM-DDTHH:mm"),
        disposition: "",
        invoice: "",
        total: "",
        comments: "",
        how_paid: "",
        reason: "",
        pictures: [],
      },
      showToast : false,
      toastColor : 'success',
      toastMessage : '',
      uploadedFile : null,
    unsubscribeScanListener: null, 
    };
  },
  computed: {
    isJobCompleted() {
      return this.form.disposition == customerModal.DISPOSITION_COMPLETE;
    },
    isJobCancelled() {
      return this.form.disposition == customerModal.DISPOSITION_CANCEL;
    },
    jobStatus() {
      return [
        {
          name: "Completed",
          value: customerModal.DISPOSITION_COMPLETE,
        },
        {
          name: "Cancelled",
          value: customerModal.DISPOSITION_CANCEL,
        },
      ];
    },
    howPaidOptions() {
      let field = this.fields.find((i) => i.id == customerModal.HOW_PAID);
      return field ? field.options : [];
    },
    reasonOptions() {
      let field = this.fields.find(
        (i) => i.id == customerModal.REASON_FOR_CANCELLATION
      );
      return field ? field.options : [];
    },
  },
  methods: {
    async removeFile(i) {
      const vm = this;
      vm.$confirm.show({
        message: "Are you sure, Do you want to delete this file?",
        onConfirm: async () => {
          vm.form.pictures.splice(i, 1);
          vm.$emit("input", vm.form.pictures);
        },
      });
    },
    onFileChange(e) {
      const vm = this;
      for (let file of e.target.files) {
        vm.form.pictures.push(file);
      }
      vm.$refs.file.value = null;
    },
    onStatusChange() {
      this.form.how_paid = "";
      this.form.reason = "";
    },
    
    
    async submit() {

      const vm = this;
      vm.loading = true;

      try {
        let uploads;
        let {data} = await functions.httpsCallable("getCustomer")({ id: this.job.id });
         uploads = data.data.uploads || [];
            let pic = [];        
            for (let file of vm.form.pictures) {
              let base64 = await vm.toBase64(file)
              pic.push({
                base64: base64,
                name: file.name,
                type: file.type,
                url: base64 
              });
            } 

            let doc = JSON.parse(JSON.stringify(vm.form));
            doc.pictures = [...uploads,...pic];
            let closeOutJob = functions.httpsCallable("closeOutJob");
            let reference = vm.$route.params.id;
            let { status, message } = (await closeOutJob({ reference, form: doc }))
            .data;

           vm.loading = false;
            if (status) {
            vm.job = {};
            vm.$alert.show("Job is closed out successfully.");
            } else {
              vm.$alert.show(message);
            }
      } catch (error) {
        vm.$alert.show(error.message);
        vm.loading = false;
      }
      console.log(this.form);
    },

    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },

    async getJobDetails() {
      const vm = this;
      try {
        vm.isLoading = true;
        let getJobDetails = functions.httpsCallable("getCloseOutJob");
        let reference = vm.$route.params.id;
        let { status, message, result } = (
          await getJobDetails({ reference, isJobAccept: false })
        ).data;
        vm.isLoading = false;
        if (status) {
          vm.job = result.customerDoc;
          console.log(vm.job);
          vm.fields = result.fields;
          this.startScanListener();
        } else {
          vm.$alert.show(message);
        }
      } catch (error) {
        vm.$alert.show(error.message);
        vm.isLoading = false;
      }
    },
    async scannrUrl(){
        let userId = this.job.id;

        const rawBackendUrl = `${appSettingModel.DRIVER_LICENSE_URL}/${userId}`;
        const encodedBackendUrl = encodeURIComponent(rawBackendUrl);
        
        const deeplink =
        'https://scannr.page.link/?' +
        'apn=co.infinum.scannrapp&' +
        'ibi=hr.infinum.photopay.scannr&' +
        'link=http://scannrapp.setup/rest-tracking/' +
        encodedBackendUrl;

       window.location.href = deeplink

       this.scannrUrlLink = deeplink;
    },
    async filScanInfo() {
      const driverLicenseInfoSnapshotInfo = await scans
      .where("customerTemplateId", "==", this.job.id)
      .get();
         
      const scanInfo = driverLicenseInfoSnapshotInfo.docs[0].data();
      
      let {data} = await functions.httpsCallable("getCustomer")({ id: this.job.id });
      if(data.data){
        let customerDocData = data.data;
          const dateOfBirthKey              = customerModal.BIRTH_DATE;
          const govermentIdKey             = customerModal.GOVERMENT_ID;
          const driverLicenseAddressKey    = customerModal.DRIVER_ADDRESS_KEY;
          
          const birthDateRaw = scanInfo.driverData.scanning_result.kPPDateOfBirth || "";
          const month = birthDateRaw.slice(0, 2);
          const day   = birthDateRaw.slice(2, 4);
          const year  = birthDateRaw.slice(4, 8);
          const formattedDOB = `${month}/${day}/${year}`;

            const govermentDriverLicense = scanInfo.driverData.scanning_result.kPPCustomerIdNumber;
            const driverAddress          = scanInfo.driverData.scanning_result.kPPAddressStreet;
  
            customerDocData.fields[dateOfBirthKey] = formattedDOB 
            customerDocData.fields[govermentIdKey] = govermentDriverLicense 
            customerDocData.fields[driverLicenseAddressKey] = driverAddress 
            let updateCustomer = functions.httpsCallable("updateCustomer");
            await updateCustomer({ id: this.job.id, doc : customerDocData  })
          }
          await this.generatePdf();
      },

    async generatePdf() {
        const driverLicenseInfoSnapshotInfo = await scans
          .where("customerTemplateId", "==", this.job.id)
          .get();
        const scanInfo = driverLicenseInfoSnapshotInfo.docs[0]?.data();
       
        if (!scanInfo) return;
        const result = scanInfo.driverData?.scanning_result;
        if (!result) return;
        const doc = new jsPDF();
        doc.setFontSize(16);
        doc.text("Driver License Info", 10, 10);

          const sortedKeys = Object.keys(result)
            .sort();

          const rows = sortedKeys.map(key =>{ 
            if(key.includes("Date")){
              const month = result[key].slice(0, 2);
              const day = result[key].slice(2, 4);
              const year = result[key].slice(4, 8);
            return [key.substring(3), `${month}/${day}/${year}` || "N/A" ]
            }else if(key == 'kPPSex'){
              return [key.substring(3), (result[key]== 1? 'Male' : "Female")|| "N/A" ]
            }else{
              return [key.substring(3), result[key] || "N/A" ]
            }
          });
         autoTable(doc, {
            head: [["Field's Name", "Driver Info"]],
            body: rows,
            startY: 20,
            margin: { horizontal: 10 },
            styles: { fontSize: 10 },
            headStyles: { fillColor: [41, 128, 185] },
          });

          const pdfBlob = doc.output("blob");
          const file = new File([pdfBlob], "driver-info.pdf", {
            type: "application/pdf",
          });
          
          
           
          const existingIndex = this.form.pictures.findIndex(
            (f) => f.name === file.name
          );

          if (existingIndex > -1) {
            this.form.pictures.splice(existingIndex, 1, file);
          } else {
            this.form.pictures.push(file);
          }
          this.uploadedFile = file;
      },
        
      downloadFile(file) {
          const url = URL.createObjectURL(file);
          const link = document.createElement('a');
          link.href = url;
          link.download = file.name;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        },
      startScanListener() {
          if (!this.job.id) return;

          // If a listener already exists, detach it first
          if (this.unsubscribeScanListener) {
            this.unsubscribeScanListener();
            this.unsubscribeScanListener = null;
          }

          // Register the real-time listener
          this.unsubscribeScanListener = scans
            .where("customerTemplateId", "==", this.job.id)
            .onSnapshot((snapshot) => {
              if (!snapshot.empty) {
                this.filScanInfo();
              }
            });
        },

  },
  mounted() {
    this.getJobDetails();
    this.filScanInfo();
  },

   beforeDestroy() {
    if (this.unsubscribeScanListener) {
      this.unsubscribeScanListener();
    }
  }
};
</script>

<style lang="scss">
.file-name {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.file-remove {
  position: relative;
  right: 20px;
  top: -2px;
  button {
    position: absolute;
    top: -15px;
    right: -75px;
  }
}
</style>